import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Card, CardBody, Badge, Button, Spinner, Alert } from "reactstrap";
import { ArrowLeft, Edit2 } from "lucide-react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import FormFillView from "../../../Components/FormFill/FormFillView";
import { getFormTree } from "../../../services/sahaInspectionService";
import { useYetki, SAYFA_IZNI } from "../../../services/rbacService";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

// ─────────────────────────────────────────────────────────────────────────────
// Form Önizleme — şablonun "Denetim Formu Doldur" sayfasında nasıl görüneceği.
// Salt okunur: yalnızca GET /inspection/generate okunur, doldurma sayfasının
// başlangıçtaki form kaydı (Mongo) açılmaz.
// ─────────────────────────────────────────────────────────────────────────────
function FormPreviewPage() {
  const { t: tx } = useTranslation("formlar");
  const { id } = useParams();
  const navigate = useNavigate();
  const duzenleyebilir = useYetki(SAYFA_IZNI.FORM_YONETIM);

  const [tree,    setTree]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = i18n.t("formlar:formPreview.sayfaBasligi");
    let ignore = false;
    async function run() {
      const data = await getFormTree(id);
      if (ignore) return;
      setTree(data);
      setLoading(false);
    }
    run();
    return () => { ignore = true; };
  }, [id]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("formPreview.onizleme")} pageTitle={tx("formPreview.formYonetimi")} />

        <Card className="border-0 bg-light mb-3">
          <CardBody className="py-3 d-flex align-items-center gap-2 flex-wrap">
            <Badge color="info" pill>{tx("formPreview.onizleme")}</Badge>
            {tree && <span className="fw-semibold">{tree.typeName}</span>}
            <span className="text-muted small">{tx("formPreview.saltOkunur")}</span>
            <div className="ms-auto d-flex gap-2">
              <Button color="light" size="sm" className="d-flex align-items-center gap-1"
                onClick={() => navigate("/Management/Forms/list")}>
                <ArrowLeft size={14} />{tx("common:geri")}
              </Button>
              {duzenleyebilir && (
                <Button color="primary" size="sm" className="d-flex align-items-center gap-1"
                  onClick={() => navigate(`/Management/Forms/${id}/edit`)}>
                  <Edit2 size={14} />{tx("common:duzenle")}
                </Button>
              )}
            </div>
          </CardBody>
        </Card>

        {loading ? (
          <div className="text-center py-5"><Spinner size="sm" className="me-2" />{tx("common:yukleniyor")}</div>
        ) : !tree ? (
          <Alert color="danger" className="py-2 small">{tx("formPreview.formYuklenemedi")}</Alert>
        ) : (
          <FormFillView
            mainQuestion={tree.mainQuestion}
            mainQuestType={tree.mainQuestionQuestType}
            categories={tree.categories || []}
            readOnly
            showProgress={false}
          />
        )}
      </Container>
    </div>
  );
}

export default FormPreviewPage;
